export default "__VITE_PUBLIC_ASSET__dd9540f6__"